import React from 'react';
import { Text, StyleSheet } from 'react-native';
import type { StyleProp, TextStyle } from 'react-native';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';

interface ParagraphProps {
	text: string;
	styles?: StyleProp<TextStyle>;
}

export default function Paragraph({ text, styles: extraStyles }: ParagraphProps) {
	return <Text style={[styles.paragraph, extraStyles]}>{text}</Text>;
}

const styles = StyleSheet.create({
	paragraph: {
		fontSize: Dimens.fontSize17,
		fontFamily: Fonts.montserratRegular,
		lineHeight: Dimens.lineHeight23,
	},
});
